<!-- eslint-disable vue/no-unused-vars -->
<template lang="">
    <div>
        <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#" @click="goback()">
                <b-icon icon="arrow-left"></b-icon> {{$route.query.desc}}
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
    
                <b-nav-item>
                    <b-button-group>
                        <!-- <b-button variant="info" @click="onListItems">
                                            <b-icon icon="list" aria-hidden="true" variant="light"></b-icon> ລາຍການ
                                        </b-button> -->
    
                        <!-- <b-button variant="danger" @click="goback()">
                                            <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon> ປິດ
                                        </b-button> -->
                    </b-button-group>
    
    
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>
    
        <b-form id="frm" name="frm" @submit="onSubmit"  @reset="onReset" ref="frm">
            <b-row>
                <b-col md="6" lg="6" p-3  >
                    <b-card>
                        <b-card>
                            <b-row>
                                <b-col>
                                    <b-form-group label="ສົກຮຽນ:" label-cols="12" label-cols-lg="3">
                                        <b-input-group>
                                            <b-form-input v-model="frm.accd" v-mask="'####-####'" placeholder="____-____" trim></b-form-input>
    
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
    
                                    <b-form-group label-cols="12" label-cols-lg="3" label="ລະຫັດໂຮງຮຽນ:" :description="'ໂຮງຮຽນ: '+schoolname">
                                        <b-form-input v-model="frm.school_id" @input="getschoolname" required trim></b-form-input>
                                    </b-form-group>
                                </b-col>
    
                            </b-row>
                            <b-row>
                                <b-col>
    
                                    <b-form-group label-cols="12" label-cols-lg="3" label="ວັນທີ ເຂົ້າຂໍ້ມູນ:">
    
                                        <b-form-datepicker required v-model="frm.creat_date" locale="lao"></b-form-datepicker>
                                    </b-form-group>
                                </b-col>
    
                            </b-row>
                        </b-card>
                        <b-card>
                            <b-row>
                                <b-col cols="12" >
    
                                    <b-form-group label-cols="12" label-cols-lg="3" label="ລາຍການ:">
                                        <!-- <b-form-input v-model="frm.item_code" @input="getItem" required trim></b-form-input> -->
                                        <b-form-select v-model="frm.item_code" v-on:change="getItem" :options="items"   trim>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12"  >
    
                                    <b-form-group label-cols="12" label-cols-lg="3" label="ວັນທີ:">
    
                                        <b-form-datepicker   v-model="frm.trans_date" locale="lao"></b-form-datepicker>
                                    </b-form-group>
                                </b-col>
    
    
                          
                                
                            </b-row>
                            <b-row>
                                <b-col cols="12"  >
    
                                    <b-form-group label-cols="12" label-cols-lg="3" label="ຈຳນວນ:">

                                        <vue-numeric ref="frm.value" currency="" class="p-1 text-right" separator="," v-model="frm.value">
                                        </vue-numeric>
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12"  >
                                    <b-form-group label-cols="12" label-cols-lg="3" label="ຫົວໜ໋ວຍ:">
                                        <b-form-select v-model="frm.unit" :options="units"  trim>
                                        </b-form-select>
                                    </b-form-group>
    
                                </b-col>


                                <b-col cols="12"  >
    
                                    <b-form-group label-cols="12" label-cols-lg="3" label="ຈຳນວນເງິນ:">
    
                                        <vue-numeric ref="frm.amount" currency="" class="p-1 text-right" separator="," v-model="frm.amount">
                                        </vue-numeric>
                                    </b-form-group>
                                </b-col>


                                <b-col cols="12"  >
                                    <b-form-group label-cols="12" label-cols-lg="3" label="ແຫຼ່ງທຶນ:">
                                        <b-form-select v-model="frm.source_type" :options="source_types"  trim>
                                        </b-form-select>
                                    </b-form-group>
    
                                </b-col>
                          
                            </b-row>
                            <!-- <b-row>
                                <b-col>
                                    <b-button variant="outline-primary" block @click="onAdditem">ເພີ່ມລາຍການ</b-button>
    
                                </b-col>
                            </b-row>
     -->
                        </b-card>
<!--     
                        <b-row>
                            <b-col>
                                <b-card>
                                    <b-table head-variant="light" hover :fields="fields" :items="frm.items" class="border  mt-2" foot-clone>
    
                                        <template #cell(action)="item">
            
                                                   
                                                    <b-link  @click="onRemoveItem(item.index)">
                                                        <b-icon icon="trash" variant="danger"></b-icon> 
                                                    </b-link>
</template>

<template #foot(description)="data">
    <span class="text-danger">ລວມ: </span>
</template>
<template #foot(value)="data">
    <span class="text-danger"></span>
</template>
<template #foot(unit)="data">
    <span class="text-danger"></span>
</template>
<template #foot(description)="data">
    <span class="text-danger">ລວມ: </span>
</template>

<template #foot(trans_date)="data">
    <span class="text-danger"></span>
</template>
                                        // eslint-disable-next-line vue/no-unused-vars
<template #foot(amount)="data">
    <span class="text-danger">{{ Total }}</span>
</template>

<template #foot(source_type)="data">
    <span class="text-danger"></span>
</template>
                                    </b-table>
                                </b-card>
                            </b-col>
                        </b-row>
                         -->
                        <b-row>
                            <b-col>
                                <!-- <b-button type="" variant="primary" block @click="onAdditem">ບັນທຶກລາຍການ</b-button> -->
                                <b-button type="submit" block variant="primary">Submit</b-button>
    
                            </b-col>
                            <b-col>
                                <b-button type="reset" block variant="danger">Reset</b-button>
                            </b-col>
                        </b-row>
    
                    </b-card>
                </b-col>
            </b-row>
    
        </b-form>
    </div>
</template>

<script>
import axios from "axios";
export default {
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);
        this.frm.create_by = this.user.username
        this.frm.school_id=this.user.school_id
        axios
            .get(this.$store.getters.getBaseUrl + "/getItems/source_types/source_type_desc/source_type", {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.source_types = response.data;
            })

        axios
            .get(this.$store.getters.getBaseUrl + "/getItems/items/item_desc_lao/item_code", {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.items = response.data;
            })

            axios
            .get(this.$store.getters.getBaseUrl + "/getItems/units/unite_desc/unite_desc", {
                headers: {
                    'Authorization': 'Bearer ' + this.user.login_hash
                }
            })
            .then((response) => {
                // JSON responses are automatically parsed.
                this.units = response.data;
            })
    },
    data() {
        return {
            user: [],
            source_types: [],
            items: [],
            fields: [
                { label: 'ລາຍການ', key: 'description', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ວັນທີ', key: 'trans_date', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ຈຳນວນ', key: 'value', thClass: "col-md-2  text-right", tdClass: "col-md-2 text-right", formatter: "format" },
                { label: 'ຫົວໜ່ວຍ', key: 'unit', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: 'ຈຳນວນເງີນ', key: 'amount', thClass: "col-md-2  text-right", tdClass: "col-md-2 text-right", formatter: "format" },
                // { label: 'ແຫຼ່ງທືນ', key: 'source_type', thClass: "col-md-2", tdClass: "col-md-2" },
                { label: '...', key: 'action', thClass: "  text-right", tdClass: " text-right" },
            ],
            item: {
                "trans_date": "",
                "item_code": "",
                "description": "",
                "amount": 0,
                "value":0,
                "unit":"",
                "source_type": "GOV",
            },
            frm: {
                "item_code": "",
                "creat_date": "",
                "create_by": "",
                "trans_date": "",
                "total": 0,
                "status": "N",
                "del_by": "",
                "del_date": "",
                "update_by": "",
                "update_date": "",
                "ref_no": "",
                "description": "",
                "school_id": "",
                "source_type": "GOV",
                "accd": "",
            //    "items": [],
                "value":0,
                "unit":"",
                "amount": 0,
                
            },
            schoolname: "",
            units:""
        }
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        unformat(val) {
            var group = new Intl.NumberFormat('en-US').format(1111).replace(/1/g, '');
            var decimal = new Intl.NumberFormat('en-US').format(1.1).replace(/1/g, '');
            var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
            reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
            return Number.isNaN(reversedVal) ? 0 : reversedVal;
        },
        getschoolname() {

            axios
                .get(this.$store.getters.getBaseUrl + "/getRows/v_schools/school_id/" + this.frm.school_id, {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                })
                .then((response) => {
                    // JSON responses are automatically parsed.
                    try {
                        this.schoolname = response.data[0].school_name_lao +", ເມືອງ: "+response.data[0].district.district_name_lao +", ແຂວງ: "+response.data[0].province.prov_name;
                    } catch (error) {
                        this.schoolname = ""
                    }

                    // let rp= response.data;

                    //  console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        getItem() {
            axios
                .get(this.$store.getters.getBaseUrl + "/getRows/items/item_code/" + this.item.item_code, {
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                })
                .then((response) => {
                    // JSON responses are automatically parsed.
                    try {
                        this.item.description = response.data[0].item_desc_lao;
                    } catch (error) {
                        this.item.description = ""
                    }

                    // let rp= response.data;

                    //  console.log(  JSON.parse(response.data))
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
        onSubmit(event) {
            event.preventDefault();
            let rp_data = null;
            let sum = this.frm.items.reduce(function(total, currentValue) {
                //  console.log(currentValue.Y)
                return total + parseFloat(currentValue.amount);
            }, 0);
                this.frm.total=sum
            let postsdata = {
                table: "payment_trans",
                rows: this.frm,
            };
            axios
                .post(
                    this.$store.getters.getBaseUrl + "/jsoninsert",
                    postsdata, {
                        headers: {
                            'Authorization': 'Bearer ' + this.user.login_hash
                        }
                    }
                )
                .then((rep) => {
                    rp_data = rep.data;
                    if (rp_data.msg == "Done") {
                        // alert(rp_data.desc);

                        this.$bvModal
                            .msgBoxOk(rp_data.desc, {
                                title: "ຂໍ້ວາມາແຈ້ງ.....",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })

                    } else {
                        //alert(rp_data.desc);
                        this.$bvModal
                            .msgBoxOk(rp_data.desc, {
                                title: "Confirmation",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                    }
                });

        },
        onAdditem() {
            let row = {
                "trans_date": this.item.trans_date,
                "item_code": this.item.item_code,
                "description": this.item.description,
                "amount": this.item.amount,
                "source_type": this.item.source_type,
                "value": this.item.value,
                "unit": this.item.unit,
            }
            this.frm.items.push(row)
            this.item = {
                "trans_date": "",
                "item_code": "",
                "description": "",
                "amount": 0,
                "value":0,
                "unit":"",
                "source_type": "GOV",
            }
        },
        onRemoveItem(index) {
            this.frm.items.splice(index, 1)
        },
        total() {

            let sum = this.frm.items.reduce(function(total, currentValue) {
                //  console.log(currentValue.Y)
                return total + parseFloat(currentValue.amount);
            }, 0);

            return this.format(sum);

        },
        onReset(event) {
        event.preventDefault()

            this.frm.items=[]

        }

    },

    computed: {
        Total() {

            let sum = this.frm.items.reduce(function(total, currentValue) {
                //  console.log(currentValue.Y)
                return total + parseFloat(currentValue.amount);
            }, 0);

            return this.format(sum);

        },
    },
    filters: {
        format(number) {
            let amt = new Intl.NumberFormat('en-US', { maximumSignificantDigits: 3 }).format(number)
            return amt
        },
        unformat(val) {
            var group = new Intl.NumberFormat('en-US').format(1111).replace(/1/g, '');
            var decimal = new Intl.NumberFormat('en-US').format(1.1).replace(/1/g, '');
            var reversedVal = val.replace(new RegExp('\\' + group, 'g'), '');
            reversedVal = reversedVal.replace(new RegExp('\\' + decimal, 'g'), '.');
            return Number.isNaN(reversedVal) ? 0 : reversedVal;
        },
    }

}
</script>

<style lang="">

</style>